import LocationPrediction from '../Models/LocationPrediction';

function convertGoogleAutocompletePredictionsToLocationPredictions(
    onlyCountries: boolean,
    results?: google.maps.places.AutocompletePrediction[],
): LocationPrediction[] {
    if (results === undefined) return [] as LocationPrediction[];

    let filteredResults = results;

    if (onlyCountries) {
        filteredResults = results.filter((x) => x.types.includes('country'));
    }

    return filteredResults.map((result: google.maps.places.AutocompletePrediction) => {
        return {
            locationId: result.place_id,
            description: result.description,
            mainText: result.structured_formatting.main_text,
            secondaryText: result.structured_formatting.secondary_text,
            mainTextMatchedSubstrings: result.structured_formatting.main_text_matched_substrings,
        } as LocationPrediction;
    });
}

export default convertGoogleAutocompletePredictionsToLocationPredictions;
